export default "__VITE_ASSET__0778a74c__"